import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WishService {

  Url: string;
  constructor(public http: HttpClient) {
      this.Url = GlobalConstants.apiURL;;
  }

  public async GetWish(IdUsuario: number) {
    let params = new HttpParams().set("IdUsuario", IdUsuario);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return await lastValueFrom(this.http.get(this.Url + '/getWish',{params}));
  }
  public async DeleteWish(IdWish: number) {
    let params = new HttpParams().set("IdWish", IdWish);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return await lastValueFrom(this.http.delete(this.Url + '/deleteWish',{params}));
  }
  public GuardaryEditarWish(DatosWish:any) {
    let json = JSON.stringify(DatosWish);
    let params = json;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return lastValueFrom(this.http.post(this.Url + '/addEditWish', params, { headers: headers }));
  }
}
